import type { RootState } from 'redux/reducer'

/** 直接回傳 slice 本身，引用穩定，不會每次呼叫產生新物件 */
export const selectPreloadShare = (state: RootState) => state.preloadConfig

/** 供 saga 標註 `yield select(selectPreloadShare)` 的回傳型別，避免各處重複推導 */
export type PreloadShare = ReturnType<typeof selectPreloadShare>
